import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl } from '../UploadDocument/apiUrl';
import { toast } from '@ohif/ui-next';
import DesktopSidebar from './Sidebar/SidebarDesktop'; // Nuevo componente
import MobileBottomBar from './Sidebar/SidebarMobile';
import UploadTemplateModal from './bottom/UploadTemplate'; // Nuevo componente para el modal

const SidebarNavigation = ({ onFilterToggle }) => {
  const navigate = useNavigate();
  const [rolUsuario, setRolUsuario] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);

  // --- Lógica del archivo y subida ---

  const handleFileChange = event => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!file) {
      alert('Por favor selecciona un archivo.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(apiUrl + '/api/documentos/document/template', {
        method: 'POST',
        body: formData,
      });
      const res = await response.json();
      if (response.status !== 200) {
        toast.warning(res.message || 'Error al subir el archivo.');
      } else {
        setShowModal(false);
        toast.success(res.message || 'Archivo subido con éxito.');
      }
    } catch (error) {
      toast.error(error.message || 'Error al subir el archivo.');
    }
  };

  // --- Lógica de inicialización y navegación ---

  useEffect(() => {
    const localStr = localStorage.getItem('usuario');
    const session = localStr ? JSON.parse(localStr) : null;
    const tiposUsuario = session ? session.user.role : '';

    setRolUsuario(tiposUsuario);
  }, []);

  const onToggleTemplate = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleNavigation = path => {
    navigate(path);
  };

  // --- Renderizado de los componentes de UI ---

  return (
    <>
      <DesktopSidebar
        rolUsuario={rolUsuario}
        onFilterToggle={onFilterToggle}
        onNavigation={handleNavigation}
        onToggleTemplate={onToggleTemplate}
      />

      <MobileBottomBar
        rolUsuario={rolUsuario}
        onFilterToggle={onFilterToggle}
        onNavigation={handleNavigation}
        onToggleTemplate={onToggleTemplate}
      />

      <UploadTemplateModal
        showModal={showModal}
        closeModal={closeModal}
        handleSubmit={handleSubmit}
        handleFileChange={handleFileChange}
        apiUrl={apiUrl}
      />
    </>
  );
};

export default SidebarNavigation;
